export default [
    {
        path: '/settings/sales',

        name: 'Sales Settings',

        component: () => import('@/views/pages/settings/sales'),
    },
    {
        path: '/settings/sms',

        name: 'SMS Settings',

        component: () => import('@/views/pages/settings/sms'),
    },
];